var map = {
	"./Uplayplus_LP_carousel_ACOD_desktop.webp": 22,
	"./Uplayplus_LP_carousel_ACOD_mobile.webp": 23,
	"./Uplayplus_LP_carousel_ACV_desktop.webp": 24,
	"./Uplayplus_LP_carousel_ACV_mobile.webp": 25,
	"./Uplayplus_LP_carousel_Anno1800_desktop.webp": 26,
	"./Uplayplus_LP_carousel_Anno1800_mobile.webp": 27,
	"./Uplayplus_LP_carousel_FC5_desktop.webp": 28,
	"./Uplayplus_LP_carousel_FC5_mobile.webp": 29,
	"./Uplayplus_LP_carousel_FCND_desktop.webp": 30,
	"./Uplayplus_LP_carousel_FCND_mobile.webp": 31,
	"./Uplayplus_LP_carousel_FH_desktop.webp": 32,
	"./Uplayplus_LP_carousel_FH_mobile.webp": 33,
	"./Uplayplus_LP_carousel_GRBP_desktop.webp": 34,
	"./Uplayplus_LP_carousel_GRBP_mobile.webp": 35,
	"./Uplayplus_LP_carousel_IFR_desktop.webp": 36,
	"./Uplayplus_LP_carousel_IFR_mobile.webp": 37,
	"./Uplayplus_LP_carousel_PoPFS_desktop.webp": 38,
	"./Uplayplus_LP_carousel_PoPFS_mobile.webp": 39,
	"./Uplayplus_LP_carousel_R6S_desktop.webp": 40,
	"./Uplayplus_LP_carousel_R6S_mobile.webp": 41,
	"./Uplayplus_LP_carousel_SCblacklist_desktop.webp": 42,
	"./Uplayplus_LP_carousel_SCblacklist_mobile.webp": 43,
	"./Uplayplus_LP_carousel_TC2_desktop.webp": 44,
	"./Uplayplus_LP_carousel_TC2_mobile.webp": 45,
	"./Uplayplus_LP_carousel_TCTD2_desktop.webp": 46,
	"./Uplayplus_LP_carousel_TCTD2_mobile.webp": 47,
	"./Uplayplus_LP_carousel_TrialsRising_desktop.webp": 48,
	"./Uplayplus_LP_carousel_TrialsRising_mobile.webp": 49,
	"./Uplayplus_LP_carousel_WDL_desktop.webp": 50,
	"./Uplayplus_LP_carousel_WDL_mobile.webp": 51,
	"./blueIcon.webp": 52,
	"./bronze_badge.webp": 53,
	"./bronze_badge_mobile.webp": 54,
	"./cut_reward_icon.webp": 55,
	"./full_reward_icon.webp": 56,
	"./gold_badge.webp": 57,
	"./gold_badge_mobile.webp": 58,
	"./greenIcon.webp": 59,
	"./keep_rewards_icons.webp": 60,
	"./platinum_badge.webp": 61,
	"./platinum_badge_mobile.webp": 62,
	"./redeem_reward_images_desktop.webp": 63,
	"./redeem_reward_images_mobile.webp": 64,
	"./rewards_video_image.webp": 65,
	"./silver_badge.webp": 66,
	"./silver_badge_mobile.webp": 67,
	"./valhala_fenyx_rysing_background_desktop.webp": 68,
	"./valhala_fenyx_rysing_background_mobile.webp": 69,
	"./valhala_fenyx_rysing_background_tablet.webp": 70,
	"./yellowIcon.webp": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 161;